import * as React from 'react';

import {LinkedEntity} from 'shells/linked-entity/linked-entity';
import {DisplayOnlyTable} from 'shells/table/display-only-table';

import type {UserSessionFragment} from 'nutshell-graphql-types';

import {EmptyState} from './empty-state';
import {useGetUserSessions} from './hooks/use-get-user-sessions';

type Props = {
    filterByUserId: string | null | undefined;
};

export function UserLoginsTable(props: Props) {
    const {userSessions, isLoading, isFirstLoad, error, hasNextPage, fetchMoreRows} =
        useGetUserSessions(props.filterByUserId || undefined);

    const columns = React.useMemo(
        () => [
            {
                id: 'user',
                Header: 'Name',
                accessor: (userSession: UserSessionFragment) =>
                    userSession.user && userSession.user,
                dataType: 'component',
                width: 150,
                hasLeftBorder: true,
                Cell: ({cell}: any) => <LinkedEntity {...cell.value} type='users' />,
            },
            {
                id: 'loginTime',
                Header: 'Login time',
                accessor: (userSession: UserSessionFragment) => userSession.loginTime,
                dataType: 'timestamp',
                width: 200,
            },
            {
                id: 'ipAddress',
                Header: 'IP address',
                accessor: (userSession: UserSessionFragment) => userSession.ipAddress,
                dataType: 'string',
                shouldTruncate: true,
                width: 120,
                hasRightBorder: true,
            },
        ],
        []
    );

    const specialStates = [
        {
            shouldRender: () =>
                !error && !userSessions.length && !isLoading && !props.filterByUserId,
            component: <EmptyState noun='user login' />,
        },
    ];

    return (
        <DisplayOnlyTable
            // @ts-expect-error
            columns={columns}
            data={userSessions}
            isLoading={isLoading}
            isFirstLoad={isFirstLoad}
            fullWidth={true}
            error={error}
            hasNextPage={hasNextPage}
            onFetchMoreRows={fetchMoreRows}
            specialStates={specialStates}
            emptyStateText='No logins were found for this user'
        />
    );
}
